import useMediaQuery from '@mui/material/useMediaQuery';

// ----------------------------------------------------------------------

/**
 * Laptop-sized browser windows: under 1440px wide or 900px tall. A 13" laptop at 100% zoom is about
 * 1290×660, so the dashboard packs itself tighter there to keep the job board in view (JT1-1830).
 */
export const COMPACT_SCREEN_QUERY = '(max-width: 1439.95px), (max-height: 899.95px)';

export function useCompactScreen(): boolean {
  return useMediaQuery(COMPACT_SCREEN_QUERY);
}
